import Link from 'next/link';
import { useCallback } from 'react';
import classes from './sizeItem.module.css';
const SizeItem = props => {
  const { filterApi, filterState, group, item, onApply, onFilterItemMouseDown, handleGenerateLinkHref } = props;
  const { removeItem, addItem } = filterApi;
  const { title, value, count, swatch_data } = item;

  const { value: swatch_data_value } = swatch_data || {};

  const isSelected = filterState && Array.from(filterState).some(filterItem => filterItem.value === item.value);

  const handleClick = useCallback(
    e => {
      onFilterItemMouseDown();
      console.log('sizeItem', e.button);

      // use only left click for selection
      if (e.button !== 0) {
        return;
      }

      if (isSelected) {
        removeItem({
          group,
          item,
        });
      } else {
        addItem({
          group,
          item,
        });
      }

      if (typeof onApply === 'function') {
        onApply(group, item);
      }
    },
    [group, item, removeItem, addItem, onApply, isSelected],
  );

  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();

        if (isSelected) {
          removeItem({
            group,
            item,
          });
        } else {
          addItem({
            group,
            item,
          });
        }

        if (typeof onApply === 'function') {
          onApply(group, item);
        }
      }
    },
    [group, item, onApply, removeItem, addItem, isSelected],
  );
  const nextPath =
    handleGenerateLinkHref &&
    handleGenerateLinkHref({
      group,
      item,
    });
  return (
    <span
      className={`${classes.root} ${isSelected ? classes.rootActive : ''}`}
      onMouseDown={handleClick}
      onKeyDown={handleKeyDown}
    >
      <Link
        href={nextPath}
        onClick={e => {
          e.preventDefault();
        }}
      >
        {title}
      </Link>
    </span>
  );
};

export default SizeItem;
